import React from 'react';

import { getUserL2Access } from 'Deer/helpers/getUserAccess';
import { SidePanelButton, SIDE_PANEL_BUTTON_SIZE } from 'components/RabbitOKRSidePanel/Components/SidePanelButton';

import {
  Activities,
  Checkin as CheckinIcon,
  Details as DetailsIcon,
  InitiativeIcon,
  Praise,
} from 'assets/assetsV1/iconComponents';

import { Checkin } from '../sections/Checkin';
import { Details } from '../sections/Details';
import { Feedback } from '../sections/Feedback';
import { History } from '../sections/History';
import { Initiatives } from '../sections/Initiatives';

export const SECTIONS = [
  {
    id: 'checkin',
    isAccessible: (isDetailAccessible?: boolean) =>
      !!isDetailAccessible && getUserL2Access().hasFeedbackAccess && getUserL2Access().hasIDPAccess,
    renderNavItem: ({ selected, onClick }) => (
      <SidePanelButton
        onClick={onClick}
        selected={selected}
        Icon={CheckinIcon}
        startIconProps={{ fill: 'none' }}
        notificationCount={null}
        size={SIDE_PANEL_BUTTON_SIZE.SMALL}
      >
        Check-in
      </SidePanelButton>
    ),
    SectionContent: Checkin,
  },
  {
    id: 'history',
    isAccessible: (isDetailAccessible?: boolean) =>
      !!isDetailAccessible && getUserL2Access().hasFeedbackAccess && getUserL2Access().hasIDPAccess,
    renderNavItem: ({ selected, onClick }) => (
      <SidePanelButton
        onClick={onClick}
        selected={selected}
        Icon={Activities}
        startIconProps={{ fill: 'none' }}
        notificationCount={null}
        size={SIDE_PANEL_BUTTON_SIZE.SMALL}
      >
        History
      </SidePanelButton>
    ),
    SectionContent: History,
  },
  {
    id: 'details',
    isAccessible: () => true,
    renderNavItem: ({ selected, onClick }) => (
      <SidePanelButton
        onClick={onClick}
        selected={selected}
        Icon={DetailsIcon}
        startIconProps={{ fill: 'none' }}
        notificationCount={null}
        size={SIDE_PANEL_BUTTON_SIZE.SMALL}
      >
        Details
      </SidePanelButton>
    ),
    SectionContent: Details,
  },
  {
    id: 'feedback',
    isAccessible: () => true,
    renderNavItem: ({ selected, onClick }) => (
      <SidePanelButton
        onClick={onClick}
        selected={selected}
        Icon={Praise}
        startIconProps={{ fill: 'none' }}
        notificationCount={null}
        size={SIDE_PANEL_BUTTON_SIZE.SMALL}
      >
        Praise/ Feedback
      </SidePanelButton>
    ),
    SectionContent: Feedback,
  },
  {
    id: 'initiatives',
    isAccessible: (isDetailAccessible?: boolean) =>
      !!isDetailAccessible && getUserL2Access().hasFeedbackAccess && getUserL2Access().hasIDPAccess,
    renderNavItem: ({ selected, onClick }) => (
      <SidePanelButton
        onClick={onClick}
        selected={selected}
        Icon={InitiativeIcon}
        startIconProps={{ fill: 'none' }}
        notificationCount={null}
        size={SIDE_PANEL_BUTTON_SIZE.SMALL}
      >
        Initiatives
      </SidePanelButton>
    ),
    SectionContent: Initiatives,
  },
];
